import { FC, InputHTMLAttributes, ReactNode } from "react";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import {clsxm} from "@/utils/clsxm";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  labelClassName?: string;
}

export const TermsAndPoliceCheckbox: FC<IProps> = ({
   labelClassName,
   checked,
   disabled,
   className,
   ...props
 }) => {
  return (
    <label
      className={clsxm(
        "group flex cursor-pointer items-center gap-3 rounded-2xl border border-stroke-v2 p-5 text-main-text-v2 hover:border-accent-button-v2",
        checked &&
        "border-accent-button-v2 text-accent-button-v2 hover:border-accent-button-v2",
        disabled && "pointer-events-none opacity-70",
        className
      )}
    >
      <input
        type="checkbox"
        className="hidden appearance-none"
        checked={checked}
        disabled={disabled}
        {...props}
      />
      <div className="h-6 min-h-6 w-6 min-w-6">
        {checked ? (
          <MdCheckBox size={24} />
        ) : (
          <MdCheckBoxOutlineBlank
            size={24}
            className="text-second-text-v2 group-hover:text-accent-button-v2"
          />
        )}
      </div>

      <div className={clsxm("text-base font-medium text-inherit", labelClassName)}>I agree to{' '}
        <a href="https://skinnyrx.com/privacy" target="_blank" rel="noopener noreferrer" className="underline">privacy
          policy</a> and{' '}
        <a href="https://skinnyrx.com/terms" target="_blank" rel="noopener noreferrer" className="underline">terms</a>
      </div>
    </label>
  );
};
